import { map, Observable } from 'rxjs';
import { PagedListModel } from '../models/paged-list-model';

export abstract class PagedListLoader {
  constructor() {

  }

  public abstract load<T, TPagedListModel extends PagedListModel<T>>(key: string, getPaged: () => Observable<TPagedListModel>): Observable<TPagedListModel>;

  // Work around for the non generic NSWAG generated PageListModel
  public loadUntyped<T, TPagedListModel extends PagedListModel<T>>(key: string, getPaged: () => Observable<any>): Observable<TPagedListModel> {
    return this.load(key, () => {
      return getPaged()
        .pipe(map(result => ({
          items: result['items'] as any[],
          totalItemCount: result['totalItemCount'] as number
        } as TPagedListModel)));
    });
  }
}
